import { Command } from 'commander';
import { formatVaultItemForHuman, redactVaultItem, unlockVault } from './shared.js';

interface ShowOptions {
    passphrase?: string;
    recoveryKey?: string;
    json?: boolean;
}

export function createVaultShowCommand(): Command {
    return new Command('show')
        .description('Show vault item summary with secrets redacted')
        .argument('<id>', 'Vault item id')
        .option('--passphrase <value>', 'Vault passphrase')
        .option('--recovery-key <value>', 'Recovery key')
        .option('-j, --json', 'Output JSON')
        .action(async function (this: Command, id: string, options: ShowOptions) {
            const { store, vmk } = await unlockVault(options);
            const item = await store.readPlainItem(vmk, id);
            const useJson = !!(options.json || this.optsWithGlobals().json);
            const redacted = redactVaultItem(item);
            if (useJson) {
                console.log(JSON.stringify({ item: redacted }, null, 2));
                return;
            }
            console.log(formatVaultItemForHuman(item, { includeBody: 'auto' }));
        });
}
